import React from 'react';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import ConsoleNewReleaseGames from '@/pages/intelligence/pages/Potential/NewReleaseGames/ConsoleGame';

export default function NewRelease() {
  const pageLogInfo = dbiPageLogMes.topChartsConsoleGamesNewRelease;
  const entityType = 'console';
  return (
    <>
      <MarqueeBanner />
      <ConsoleNewReleaseGames entityType={entityType} pageLogInfo={pageLogInfo} />
    </>
  );
}



